<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="table-topbar">
      <div class="search-holder">
        <h3>Billing - Special</h3>
      </div>
      <div class="table-action-holder">
        <div class="create">
          <a [routerLink]="['/pricing-special/create']" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Create payment plan</a>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center gap-10 second-top-bar">
      <app-special-pricing-group-search class="flex-grow-1" (onSubmit)="onSubmitSearchForm($event)"></app-special-pricing-group-search>
    </div>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-special-pricing-group-table (actions)="groupAction($event)"></app-special-pricing-group-table>
    </div>
  </div>
</div>
